import type {
  AiMatchPassStatus,
  AppConfig,
  CheckoutAttribution,
  EntitlementsView,
} from '@shared/game/types';

async function readJson<T>(response: Response): Promise<T> {
  const payload = (await response.json().catch(() => null)) as T | { error?: string } | null;
  if (!response.ok) {
    const message = payload && typeof payload === 'object' && 'error' in payload ? payload.error : undefined;
    throw new Error(message || `Error HTTP ${response.status}`);
  }
  return payload as T;
}

export async function getConfig(): Promise<AppConfig> {
  const response = await fetch('/api/config', { headers: { Accept: 'application/json' } });
  return readJson<AppConfig>(response);
}

export async function getEntitlements(token: string): Promise<EntitlementsView> {
  const response = await fetch('/api/shop/entitlements', {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
  return readJson<EntitlementsView>(response);
}

export async function getAiMatchPassStatus(token: string): Promise<AiMatchPassStatus> {
  const response = await fetch('/api/ai-match-pass/status', {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
  return readJson<AiMatchPassStatus>(response);
}

export async function activateAiMatchPassTest(token: string): Promise<AiMatchPassStatus> {
  const response = await fetch('/api/ai-match-pass/activate-test', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
  return readJson<AiMatchPassStatus>(response);
}

export async function createAiMatchPassCheckout(token: string): Promise<{ url: string }> {
  const response = await fetch('/api/ai-match-pass/checkout', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
  return readJson<{ url: string }>(response);
}

export async function createCheckout(
  token: string,
  productKey = 'voyager',
  attribution?: CheckoutAttribution,
): Promise<{ url: string }> {
  const response = await fetch('/api/shop/checkout', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ productKey, attribution }),
  });
  return readJson<{ url: string }>(response);
}
